import 'bootstrap-multiselect';
import { makeTablesResponsive } from './responsiveTables';

const searchContainer = '[data-search-container]';
const multiselectSelector = '[data-multiselect]';
const formsSelector = '[data-filtered-search-form]';
const sortingDropdownSelector = '[data-sorting]';
var radioBtn = document.getElementsByName("archive-content");

const listeners: ((scope: JQuery<HTMLElement>) => void)[] = [];

export function AddOnSearchReloadOperation(operation: (scope: JQuery<HTMLElement>) => void) {
    listeners.push(operation);
}
var bodySelector = $('body');

bindAll(bodySelector);
refreshOnTabChanged(bodySelector);

function bindMultiselects(scope: JQuery<HTMLElement>) {
    scope.find(multiselectSelector).each((i, element) => {
        const select: JQuery<HTMLElement> = $(element);
        const initialValues = select.val() as string[];
        const wrapper = select.parents('[data-multiselect-wrapper]');
        for(var i = 0; i < radioBtn.length; i++) {
            radioBtn[i].onclick = function () {
                select.parents('form').submit();
                return;
            };
        }
        (select as any).multiselect({
            buttonText: () => {
                return select.data('label');

            },
            onDropdownHide: () => {
                if (select.attr('data-submit-on-hide') !== 'false') {
                    const currentValues = select.val() as string[];

                    if (initialValues.length !== currentValues.length) {
                        select.parents('form').submit();
                        return;
                    }

                    $.each(initialValues, (index, initialValue) => {
                        if (initialValue !== currentValues[index]) {
                            select.parents('form').submit();
                            return false;
                        }
                    });
                } else {
                    bindControls(select);
                }
            },
        });

        $(() => {
            if (select.attr('data-submit-on-hide') === 'false') {
                bindControls(select);
            }
        });



        select
            .parent()
            .find('[data-multiselect-remove]')
            .each((index, buttonElement) => {
                const button = $(buttonElement);
                const value = button.val();

                button.click((e) => {
                    e.preventDefault();
                    if (value) {
                        (select as any).multiselect('deselect', value);
                    } else {
                        (select as any).multiselect('select', '');
                    }
                    select.parents('form').submit();
                });
            });
        wrapper.innerWidth(wrapper.find('.multiselect').outerWidth());
    });
}

function bindForms(scope: JQuery<HTMLElement>) {
    scope.find(formsSelector).each((i, element) => {
        const form = $(element);
        form.submit((e) => {
            e.preventDefault();

            const data = form.serializeArray();
            searchPushState(data);
            submitForm(form, form.data('callback-url'), data, true);
        });
    });
}

function bindCheckboxList(scope: JQuery<HTMLElement>) {
    scope.find('[checkbox-list-filter-item-input]').each((i, element) => {
        const input = $(element);
        input.change(function () {
            input.parents('form').submit();
        });
    });
}

function bindSorting(scope: JQuery<HTMLElement>) {
    scope.find(sortingDropdownSelector).each((i, element) => {
        const sortingElement = $(element);
        sortingElement.change(() => {
            const form = sortingElement.parents(searchContainer).children(formsSelector) as JQuery<HTMLFormElement>;
            form.find(`input[name=${sortingElement.attr('name')}]`).val(sortingElement.val());

            const keyName = sortingElement.attr('name');
            const newValue = sortingElement.val().toString();

            let serializedArray: NameValue[] = form.serializeArray() || [];

            serializedArray = modifyValue(serializedArray, keyName, newValue);

            var callbackUrl = sortingElement.data('callback-url') || form.data('callback-url');

            searchPushState(serializedArray);
            submitForm(sortingElement, callbackUrl, serializedArray);
        });
    });
}

function bindResetUrl(scope: JQuery<HTMLElement>) {
    scope.find('[data-search-nav-url]').each((index, element) => {
        const anchor = $(element);
        anchor.click((e) => {
            e.preventDefault();
            const isHiddenDropdownFilterPresent = document.getElementsByClassName('hidden-dropdown-filter').length > 0;
            const form = anchor.closest(searchContainer).find(formsSelector);

            if (isHiddenDropdownFilterPresent) {
                const data = form.serializeArray();
                data.push({ name: "resetForm", value: "true" });
                // We don't want to use the search-nav-url when there's a hidden dropdown filter
                // because the hidden dropdown filters should not be part of the URL, it could go over 2000 characters.
                searchPushState([]);
                submitForm(anchor, form.data('callback-url'), data);
            } else {
                searchPushState([]);
                submitForm(anchor, anchor.data('search-nav-url'), []);
            }
        });
    });
}

function bindGetUrl(scope: JQuery<HTMLElement>) {
    scope.find('[data-search-nav-url-with-form]').each((index, element) => {
        const anchor = $(element);

        const parentForm = anchor.parents(searchContainer).find(formsSelector);

        anchor.click((e) => {
            e.preventDefault();

            const url = anchor.data('search-nav-url-with-form');

            const formQueryString: string = parentForm.serialize();
            const urlQueryString: string = url.split('?')[1] || '';

            const queryString = urlQueryString + '&' + formQueryString;

            searchPushStateWithUrl(queryString);
            submitForm(anchor, url, formQueryString);
        });
    });
}

function refreshOnTabChanged(scope: JQuery<HTMLElement>) {
    scope.find('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        var parentBlock = $(e.target).closest('.main-content');
        bindAll(parentBlock);
    });
}

interface NameValue {
    name: string;
    value: string;
}

function modifyValue(formData: NameValue[], name: string, newValue: string) {
    formData = formData.filter((x) => x.name !== name);
    formData.push({ name: name, value: newValue });
    return formData;
}

function submitForm(
    currentElement: JQuery<HTMLElement>,
    url: string,
    data: NameValue[] | string,
    updateResult: boolean = false,
) {
    const isHiddenDropdownFilterPresent = document.getElementsByClassName('hidden-dropdown-filter').length > 0;

    const request = isHiddenDropdownFilterPresent ? $.post : $.get;

    request(url, data, (result) => {
        const html = $(result);

        currentElement.parents(searchContainer).first().replaceWith(html);

        if (updateResult) {
            html.trigger('resultsUpdate');
        }

        bindAll(html);
        makeTablesResponsive(html);
    });
}

function bindAll(scope: JQuery<HTMLElement>) {
    bindMultiselects(scope);
    bindForms(scope);
    bindGetUrl(scope);
    bindResetUrl(scope);
    bindSorting(scope);
    bindCheckboxList(scope);
    bindDropdownSubmitOnChange(scope);
    listeners.forEach((listener) => listener(scope));
}

const queryStringElementsToRemove: RegExp[] = [/currentBlock=\d+&?/, /currentPage=\d+&?/, /requirementId=[^&]*&?/g, /recordType=[^&]*&?/];

function searchPushStateWithUrl(url: string) {
    if (!url.startsWith('?')) {
        url = '?' + url;
    }

    for (let i = 0; i < queryStringElementsToRemove.length; i++) {
        url = url.replace(queryStringElementsToRemove[i], '');
    }

    window.history.pushState({}, '', url);
}

function searchPushState(values: NameValue[]) {
    values = values || [];
    const url = '?' + values.map((x) => x.name + '=' + x.value).join('&');
    searchPushStateWithUrl(url);
}

window.onpopstate = function (event) {
    $('body')
        .find(formsSelector)
        .each((i, element) => {
            let form = $(element);
            const queryString = document.location.search.replace('?', '');
            submitForm(form, form.data('callback-url'), queryString, false);
        });
};

function bindControls(select: JQuery<HTMLElement>) {
    const controls = select.siblings('[data-multiselect-controls]');

    const selectedItemControls = select
        .children('option:selected')
        .toArray()
        .map(
            ({ value, text }: HTMLOptionElement) =>
                `<button class="multiselect-remove-btn" title="${text}" type="button" value="${value}">${text}</button>`,
        );

    controls
        .empty()
        .on('click', (e) => {
            const button = $(e.target);
            select.children(`[value=${button.val()}]`).prop('selected', false);
            select
                .parent('[data-multiselect-wrapper]')
                .find('input')
                .filter((i, input: HTMLInputElement) => {
                    console.log(input.value, button.val());
                    return input.value === button.val();
                })
                .prop('checked', false);
            button.remove();
        })
        .append(...selectedItemControls);
}

function bindDropdownSubmitOnChange(scope: JQuery<HTMLElement>) {
    scope.find('[data-submit-on-change]').each((i, element) => {
        const dropdown = $(element);
        const submitOnChange = dropdown.data('submit-on-change').toLowerCase() === 'true';

        if (submitOnChange) {
            dropdown.change(() => {
                const url = new URL(window.location.href);
                let newUrl = url.origin + url.pathname;
                searchPushStateWithUrl(newUrl);
                dropdown.parents('form').submit();
                window.history.pushState({}, '', newUrl);
            });
        }
    });
}
